// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".number-input > .input {\n  text-align: right;\n}\n.number-input > .placeholder {\n  text-align: right;\n}\n", ""]);
// Exports
module.exports = exports;
